 import { types } from "../types";



export const authReducer = (state , action) => {

    switch (action.type) {
        case types.AuthLogin:
            return{
                ...action.payload, // esto hace que se coloque el nombre en el sidebar!!!!
                logged:true,
                DataLogin: action.payload
            }
        case types.AuthLogout:
            //console.log('pruebo si paso por aca');
            return{                              
                logged: false,
            }; 

        case types.AutoRedirect:
                return{
                    
                    logged: 0,
                };
                
            
            
        case types.SklLogin:
            return{
                ...action.payload,
                logged:true,
                DataLoginSkl: action.payload
            };
             

        default:
            return state;
    }

}
